export enum AlertType {
    operation = 'Operation message',
    situation = 'Situation',
}
